var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.BaseAlert,
    {
      attrs: {
        color: "text-error",
        "link-text": _setup.linkText,
        href: _setup.href,
        "data-qa": "lpu_reviews_fraud_mark",
      },
    },
    [
      _vm._v("\n  " + _vm._s(_setup.description) + "\n  "),
      _c("br"),
      _vm._v("\n  " + _vm._s(_setup.caution) + "\n"),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }